module.exports = __webpack_public_path__ + "img/shield-slash.a378e583.svg";